<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-emerald-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-emerald-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          <Icon icon="mdi:hand-coin" class="text-emerald-600" />
          Nuevo Préstamo
          <span class="px-2 sm:px-3 py-0.5 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 text-xs sm:text-sm font-black rounded-lg border border-emerald-200 dark:border-emerald-800">
            {{ form.numeroPrestamo || 'Nuevo' }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">SYSTEM JJ - Sistema de Préstamos Personales</p>
      </div>
      
      <button @click="volverAListado" class="px-3 sm:px-6 py-2 sm:py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-2 w-full sm:w-auto justify-center">
        <Icon icon="mdi:arrow-left" class="text-base sm:text-lg" />
        <span class="hidden sm:inline">Volver al listado</span>
        <span class="sm:hidden">Volver</span>
      </button>
    </div>

    <!-- Formulario en dos columnas -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
      <!-- Columna izquierda -->
      <div class="space-y-3 sm:space-y-4">
        <!-- Tarjeta de Prestatario -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-visible">
          <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:account" class="text-blue-600 dark:text-blue-400 text-base sm:text-xl" />
              </div>
              Información del Prestatario
              <span class="ml-2 text-[8px] sm:text-[10px] bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-1.5 sm:px-2 py-0.5 rounded-full font-bold">* Requerido</span>
            </h2>
          </div>
          <div class="p-3 sm:p-4 overflow-visible">
            <!-- Selección de Tipo -->
            <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl mb-3 sm:mb-4">
              <button @click="cambiarTipo('empleado')" :class="['flex-1 px-2 sm:px-4 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-medium rounded-lg transition-all duration-200', form.tipoPrestatario === 'empleado' ? 'bg-white dark:bg-gray-800 text-purple-600 dark:text-purple-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
                <Icon icon="mdi:account-tie" class="inline mr-1 text-sm" /> Empleado
              </button>
              <button @click="cambiarTipo('cliente')" :class="['flex-1 px-2 sm:px-4 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-medium rounded-lg transition-all duration-200', form.tipoPrestatario === 'cliente' ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
                <Icon icon="mdi:account" class="inline mr-1 text-sm" /> Cliente
              </button>
              <button @click="cambiarTipo('externo')" :class="['flex-1 px-2 sm:px-4 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-medium rounded-lg transition-all duration-200', form.tipoPrestatario === 'externo' ? 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
                <Icon icon="mdi:account-outline" class="inline mr-1 text-sm" /> Externo
              </button>
            </div>

            <!-- Modo Buscar (Empleado o Cliente) -->
            <div v-if="form.tipoPrestatario !== 'externo'" class="relative" style="z-index: 100;">
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">
                Buscar {{ form.tipoPrestatario === 'empleado' ? 'Empleado' : 'Cliente' }}
              </label>
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                <input 
                  v-model="buscarTexto" 
                  type="text" 
                  :placeholder="form.tipoPrestatario === 'empleado' ? 'Nombre, email...' : 'Nombre, documento, teléfono o email...'" 
                  class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-xs sm:text-sm" 
                  @input="debounceBuscar"
                  @focus="mostrarResultadosSiHay"
                />
              </div>
              
              <!-- Dropdown de resultados -->
              <div v-if="resultadosBusqueda.length > 0" class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-60 sm:max-h-72 overflow-y-auto" style="z-index: 9999; min-width: 300px;">
                <div v-for="item in resultadosBusqueda" :key="item.id" @click="seleccionarPrestatario(item)" class="p-2 sm:p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                  <div class="flex items-start gap-2 sm:gap-3">
                    <div class="p-1.5 sm:p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg">
                      <Icon icon="mdi:account-circle" class="text-emerald-600 dark:text-emerald-400 text-base sm:text-xl" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                        <div>
                          <p class="font-semibold text-gray-800 dark:text-white text-xs sm:text-sm">{{ item.nombre }} {{ item.apellido || '' }}</p>
                          <p class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ item.documento || item.email || '' }}</p>
                          <div class="flex flex-wrap items-center gap-2 sm:gap-3 mt-1 text-[9px] sm:text-xs text-gray-500 dark:text-gray-400">
                            <span v-if="item.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-0.5 sm:mr-1 text-xs" />{{ item.telefono }}</span>
                            <span v-if="item.email" class="flex items-center"><Icon icon="mdi:email" class="mr-0.5 sm:mr-1 text-xs" />{{ item.email }}</span>
                          </div>
                        </div>
                        <Icon v-if="esSeleccionado(item)" icon="mdi:check-circle" class="text-green-500 text-lg sm:text-2xl flex-shrink-0" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Mensaje de "No encontrado" -->
              <div v-if="buscarTexto && buscarTexto.trim().length >= 2 && !cargando && resultadosBusqueda.length === 0" class="absolute mt-2 w-full p-4 sm:p-6 text-center bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700" style="z-index: 9999;">
                <Icon icon="mdi:account-search" class="text-3xl sm:text-4xl text-gray-400 mx-auto mb-2" />
                <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2 sm:mb-3">No encontramos "{{ buscarTexto }}"</p>
                <button @click="modoCrear = true" class="px-3 sm:px-4 py-1.5 sm:py-2 bg-emerald-600 text-white text-[10px] sm:text-sm rounded-lg hover:bg-emerald-700 transition-colors inline-flex items-center gap-1 sm:gap-2">
                  <Icon icon="mdi:account-plus" /> Crear {{ form.tipoPrestatario === 'empleado' ? 'empleado' : 'cliente' }}
                </button>
              </div>
              
              <!-- Cargando -->
              <div v-if="cargando" class="absolute mt-2 w-full p-3 sm:p-4 text-center bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-2xl" style="z-index: 9999;">
                <div class="inline-block animate-spin rounded-full h-4 sm:h-5 w-4 sm:w-5 border-2 border-emerald-500 border-t-transparent"></div>
                <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-1 sm:mt-2">Buscando...</p>
              </div>
            </div>

            <!-- Modo Crear -->
            <div v-if="modoCrear || form.tipoPrestatario === 'externo'" class="mt-2">
              <div class="flex items-center justify-between mb-3">
                <h3 class="text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2">
                  <Icon icon="mdi:account-plus" class="text-emerald-600" />
                  Crear {{ form.tipoPrestatario === 'empleado' ? 'Empleado' : (form.tipoPrestatario === 'cliente' ? 'Cliente' : 'Externo') }}
                </h3>
                <button v-if="form.tipoPrestatario !== 'externo'" @click="modoCrear = false; buscarTexto = ''; resultadosBusqueda = []" class="text-[10px] sm:text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">Cancelar</button>
              </div>
              
              <form @submit.prevent="guardarNuevoPrestatario" class="space-y-3 sm:space-y-4">
                <div class="grid grid-cols-2 gap-2 sm:gap-3">
                  <!-- Para Externo -->
                  <template v-if="form.tipoPrestatario === 'externo'">
                    <div class="col-span-2">
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Nombre Completo <span class="text-red-500">*</span></label>
                      <input v-model="nuevoExterno.nombre" type="text" placeholder="Nombre completo" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Cédula</label>
                      <input v-model="nuevoExterno.cedula" type="text" placeholder="V-12345678" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Teléfono</label>
                      <input v-model="nuevoExterno.telefono" type="text" placeholder="0414-7470715" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                  </template>
                  
                  <!-- Para Cliente -->
                  <template v-else-if="form.tipoPrestatario === 'cliente'">
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Tipo Doc. <span class="text-red-500">*</span></label>
                      <select v-model="nuevoCliente.tipoDocumento" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm">
                        <option value="">Seleccionar...</option>
                        <option value="cedula">Cédula</option>
                        <option value="rif">RIF</option>
                        <option value="pasaporte">Pasaporte</option>
                        <option value="identificacion_extranjera">Extranjera</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Documento <span class="text-red-500">*</span></label>
                      <input v-model="nuevoCliente.documento" type="text" :placeholder="getPlaceholderDocumento(nuevoCliente.tipoDocumento)" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Nombre <span class="text-red-500">*</span></label>
                      <input v-model="nuevoCliente.nombre" type="text" placeholder="Ej: Juan" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Apellido</label>
                      <input v-model="nuevoCliente.apellido" type="text" placeholder="Ej: Rodríguez" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Teléfono</label>
                      <input v-model="nuevoCliente.telefono" type="text" placeholder="0414-7470715" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                    <div>
                      <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Email</label>
                      <input v-model="nuevoCliente.email" type="email" placeholder="ejemplo@email.com" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
                    </div>
                  </template>
                  
                  <!-- Para Empleado -->
                  <template v-else>
                    <div class="col-span-2 text-center py-4">
                      <Icon icon="mdi:information" class="text-3xl text-gray-400 mx-auto mb-2" />
                      <p class="text-sm text-gray-600 dark:text-gray-400">Los empleados se crean en el módulo de <span class="font-bold text-emerald-600">Usuarios</span></p>
                      <button @click="modoCrear = false; buscarTexto = ''; resultadosBusqueda = []" class="mt-2 px-4 py-1.5 bg-gray-200 dark:bg-gray-700 rounded-lg text-xs font-medium">Volver a buscar</button>
                    </div>
                  </template>
                </div>
                
                <div v-if="form.tipoPrestatario !== 'empleado'" class="flex flex-col sm:flex-row gap-2 sm:gap-3 pt-1 sm:pt-2">
                  <button type="submit" :disabled="!puedeGuardarPrestatario || guardandoPrestatario" :class="['flex-1 px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 font-medium text-[10px] sm:text-sm', puedeGuardarPrestatario && !guardandoPrestatario ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white hover:from-emerald-700 hover:to-teal-700 shadow-md hover:shadow-lg' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                    <Icon v-if="guardandoPrestatario" icon="mdi:loading" class="animate-spin text-base sm:text-lg" />
                    <Icon v-else icon="mdi:account-plus" class="text-base sm:text-lg" />
                    {{ guardandoPrestatario ? 'Guardando...' : 'Guardar y Seleccionar' }}
                  </button>
                  <button v-if="form.tipoPrestatario !== 'externo'" type="button" @click="modoCrear = false; buscarTexto = ''; resultadosBusqueda = []" class="flex-1 px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 text-[10px] sm:text-sm">Cancelar</button>
                </div>
              </form>
            </div>
            
            <!-- Prestatario Seleccionado -->
            <div v-if="prestatarioSeleccionado" class="mt-4 sm:mt-6 p-3 sm:p-5 bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-emerald-200 dark:border-emerald-800/50">
              <div class="flex items-start gap-2 sm:gap-3">
                <div class="p-1.5 sm:p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg">
                  <Icon icon="mdi:account-check" class="text-emerald-600 dark:text-emerald-400 text-xl sm:text-2xl" />
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-white text-sm sm:text-lg">{{ prestatarioSeleccionado.nombre }} {{ prestatarioSeleccionado.apellido || '' }}</p>
                      <p class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ prestatarioSeleccionado.documento || prestatarioSeleccionado.cedula || prestatarioSeleccionado.email || '' }}</p>
                      <div class="flex flex-wrap gap-2 sm:gap-3 mt-1 text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">
                        <span v-if="prestatarioSeleccionado.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-0.5 sm:mr-1 text-gray-400" />{{ prestatarioSeleccionado.telefono }}</span>
                        <span v-if="prestatarioSeleccionado.email" class="flex items-center"><Icon icon="mdi:email" class="mr-0.5 sm:mr-1 text-gray-400" />{{ prestatarioSeleccionado.email }}</span>
                      </div>
                      <span class="inline-flex items-center gap-1 mt-1 sm:mt-2 px-2 py-0.5 bg-gray-100 dark:bg-gray-700 rounded-lg text-[8px] sm:text-[10px] font-bold text-gray-600 dark:text-gray-400">
                        <Icon icon="mdi:tag" class="text-xs" />
                        {{ formatearTipoPrestatario(form.tipoPrestatario) }}
                      </span>
                    </div>
                    <button @click="deseleccionarPrestatario" class="p-1.5 sm:p-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200 self-start" title="Cambiar prestatario">
                      <Icon icon="mdi:close" class="text-lg sm:text-xl" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Información del Préstamo -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:file-document" class="text-emerald-600 dark:text-emerald-400 text-base sm:text-xl" />
              </div>
              Detalles del Préstamo
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-2 sm:space-y-3">
            <div>
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Número de Préstamo</label>
              <div class="relative">
                <Icon icon="mdi:tag" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                <input v-model="form.numeroPrestamo" type="text" readonly class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-600 dark:text-gray-400 cursor-not-allowed font-mono text-[10px] sm:text-sm" />
              </div>
            </div>
            <div>
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Fecha del Préstamo</label>
              <div class="relative">
                <Icon icon="mdi:calendar" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                <input v-model="form.fechaPrestamo" type="datetime-local" class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna derecha -->
      <div class="space-y-3 sm:space-y-4">
        <!-- Montos -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:cash-multiple" class="text-amber-600 dark:text-amber-400 text-base sm:text-xl" />
              </div>
              Montos e Intereses
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-3 sm:space-y-4">
            <div class="grid grid-cols-2 gap-2 sm:gap-3">
              <div>
                <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Monto en USD <span class="text-red-500">*</span></label>
                <div class="relative">
                  <span class="absolute left-2 sm:left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] sm:text-sm">$</span>
                  <input v-model.number="form.montoUsd" type="number" step="0.01" min="0" required class="w-full pl-6 sm:pl-8 pr-2 sm:pr-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl text-right bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 font-medium text-[10px] sm:text-sm" placeholder="0.00" @input="calcularMontoBs" />
                </div>
              </div>
              <div>
                <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Monto en Bs</label>
                <div class="relative">
                  <span class="absolute left-2 sm:left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] sm:text-sm">Bs</span>
                  <input v-model.number="form.montoBs" type="number" step="0.01" min="0" readonly class="w-full pl-7 sm:pl-9 pr-2 sm:pr-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl text-right bg-gray-100 dark:bg-gray-700/50 text-gray-600 dark:text-gray-400 font-medium text-[10px] sm:text-sm cursor-not-allowed" placeholder="0.00" />
                </div>
                <p class="text-[8px] text-gray-400 mt-0.5">* Calculado automáticamente con tasa de venta actual</p>
              </div>
            </div>
            
            <!-- Tasa de cambio actual -->
            <div class="flex justify-between items-center p-2 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-600">
              <span class="text-[10px] text-gray-600 dark:text-gray-400 font-medium">Tasa de venta actual:</span>
              <span class="text-sm font-bold text-emerald-600 dark:text-emerald-400">{{ formatCurrencyBs(tasaVentaActual || 0) }}</span>
              <button @click="cargarTasaVenta" class="p-1 text-gray-400 hover:text-emerald-600 transition-colors" title="Actualizar tasa">
                <Icon icon="mdi:refresh" :class="{'animate-spin': cargandoTasa}" class="text-base" />
              </button>
            </div>

            <div class="grid grid-cols-2 gap-2 sm:gap-3">
              <div>
                <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Interés (%)</label>
                <div class="relative">
                  <input v-model.number="form.interesPorcentaje" type="number" step="0.01" min="0" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 font-medium text-[10px] sm:text-sm text-center" placeholder="0.00" @input="calcularTotales" />
                  <span class="absolute right-2 sm:right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-[10px] sm:text-sm">%</span>
                </div>
              </div>
              <div>
                <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Cuotas</label>
                <input v-model.number="form.numeroCuotas" type="number" min="1" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl text-center bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 font-medium text-[10px] sm:text-sm" placeholder="1" />
              </div>
            </div>

            <div>
              <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Fecha de Vencimiento <span class="text-red-500">*</span></label>
              <input v-model="form.fechaVencimiento" type="date" required class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 font-medium text-[10px] sm:text-sm" />
            </div>

            <!-- Resumen de Intereses -->
            <div v-if="form.montoUsd > 0" class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700">
              <p class="text-[10px] sm:text-xs font-black text-gray-400 uppercase tracking-widest mb-2">Resumen de Deuda</p>
              <div class="space-y-1 sm:space-y-2 text-[10px] sm:text-sm">
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Monto Principal USD:</span>
                  <span class="font-bold text-gray-900 dark:text-white">{{ formatCurrency(form.montoUsd || 0) }}</span>
                </div>
                <div v-if="form.montoBs > 0" class="flex justify-between">
                  <span class="text-gray-600 dark:text-gray-400">Monto Principal Bs:</span>
                  <span class="font-bold text-gray-900 dark:text-white">{{ formatCurrencyBs(form.montoBs || 0) }}</span>
                </div>
                <div class="flex justify-between" v-if="form.interesPorcentaje > 0">
                  <span class="text-gray-600 dark:text-gray-400">Interés ({{ form.interesPorcentaje }}%):</span>
                  <span class="font-bold text-amber-600">{{ formatCurrency(calcularInteresUsd()) }}</span>
                </div>
                <div class="flex justify-between border-t border-gray-200 dark:border-gray-600 pt-1 sm:pt-2">
                  <span class="font-bold text-gray-700 dark:text-gray-300">Total Deuda USD:</span>
                  <span class="font-bold text-emerald-600">{{ formatCurrency(calcularTotalDeudaUsd()) }}</span>
                </div>
                <div v-if="form.montoBs > 0" class="flex justify-between border-t border-gray-200 dark:border-gray-600 pt-1 sm:pt-2">
                  <span class="font-bold text-gray-700 dark:text-gray-300">Total Deuda Bs:</span>
                  <span class="font-bold text-emerald-600">{{ formatCurrencyBs(calcularTotalDeudaBs()) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Configuración del Préstamo -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-purple-50 to-violet-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:cog" class="text-purple-600 dark:text-purple-400 text-base sm:text-xl" />
              </div>
              Configuración
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-3 sm:space-y-4">
            <div>
              <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Motivo</label>
              <input v-model="form.motivo" type="text" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" placeholder="Motivo del préstamo" />
            </div>
            <div>
              <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Observaciones</label>
              <textarea v-model="form.observaciones" rows="2" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm resize-none" placeholder="Observaciones adicionales..."></textarea>
            </div>
          </div>
        </div>

        <!-- Resumen y Botón Crear -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:calculator" class="text-indigo-600 dark:text-indigo-400 text-base sm:text-xl" />
              </div>
              Resumen del Préstamo
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-2 sm:space-y-3">
            <div class="space-y-1 sm:space-y-2">
              <div class="flex justify-between items-center py-1">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Monto Total USD:</span>
                <span class="font-semibold text-gray-800 dark:text-white text-xs sm:text-base">{{ formatCurrency(calcularTotalDeudaUsd()) }}</span>
              </div>
              <div v-if="form.montoBs > 0" class="flex justify-between items-center py-1">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Monto Total Bs:</span>
                <span class="font-semibold text-gray-800 dark:text-white text-xs sm:text-base">{{ formatCurrencyBs(calcularTotalDeudaBs()) }}</span>
              </div>
              <div class="flex justify-between items-center py-1 border-t border-gray-200 dark:border-gray-700 pt-2">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">N° Cuotas:</span>
                <span class="font-semibold text-gray-800 dark:text-white">{{ form.numeroCuotas || 1 }}</span>
              </div>
              <div class="flex justify-between items-center py-1">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Prestatario:</span>
                <span class="font-semibold text-emerald-600 dark:text-emerald-400 text-xs sm:text-sm truncate max-w-[150px]">{{ prestatarioSeleccionado?.nombre || 'Sin seleccionar' }}</span>
              </div>
            </div>

            <div class="pt-2">
              <button @click="crearPrestamo" :disabled="!puedeCrearPrestamo || guardando" :class="['w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 font-semibold text-sm sm:text-lg shadow-lg hover:shadow-xl', puedeCrearPrestamo && !guardando ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white hover:from-emerald-700 hover:to-teal-700' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                <Icon v-if="guardando" icon="mdi:loading" class="animate-spin text-base sm:text-xl" />
                <Icon v-else icon="mdi:check-circle-outline" class="text-base sm:text-xl" />
                {{ guardando ? 'Creando Préstamo...' : 'Crear Préstamo' }}
              </button>
              <div v-if="!puedeCrearPrestamo && !guardando" class="mt-2 sm:mt-3 space-y-0.5 sm:space-y-1">
                <p v-if="!prestatarioSeleccionado" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Seleccionar un prestatario</p>
                <p v-else-if="!form.montoUsd" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Especificar el monto en USD</p>
                <p v-else-if="!form.fechaVencimiento" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Fecha de vencimiento</p>
                <p v-else-if="form.numeroCuotas < 1" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Número de cuotas (mínimo 1)</p>
                <p v-else-if="!form.numeroPrestamo" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Número de préstamo</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIRMACIÓN -->
    <Teleport to="body">
      <div v-if="showConfirmModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[60]">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
          <div class="p-4 sm:p-6">
            <div class="flex justify-center mb-3 sm:mb-4">
              <div class="p-2 sm:p-3 rounded-full" :class="confirmModalIconClass">
                <Icon :icon="confirmModalIcon" class="text-3xl sm:text-4xl" :class="confirmModalIconColor" />
              </div>
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-center text-gray-900 dark:text-white mb-1 sm:mb-2">{{ confirmModalTitle }}</h3>
            <p class="text-center text-gray-600 dark:text-gray-400 text-xs sm:text-sm mb-4 sm:mb-6" v-html="confirmModalMessage"></p>
            <div class="flex flex-col sm:flex-row gap-2 sm:gap-3">
              <button v-if="confirmModalType !== 'info'" @click="cancelarConfirmacion" class="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-3 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 text-[10px] sm:text-sm">{{ confirmModalCancelText }}</button>
              <button @click="aceptarConfirmacion" class="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-3 rounded-xl transition-all duration-200 font-medium text-white text-[10px] sm:text-sm" :class="confirmModalConfirmClass">{{ confirmModalConfirmText }}</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { crearPrestamo } from '@/api/prestamos.js';
import { obtenerClientes, crearCliente } from '@/api/clientes.js';
import { obtenerUsuarios } from '@/api/usuarios.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';
import { getCurrentUser } from "@/utils/permissionUtils";

export default {
  name: 'PrestamoCreate',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      form: {
        numeroPrestamo: '',
        tipoPrestatario: 'empleado',
        idUsuario: null,
        idCliente: null,
        nombrePrestatario: null,
        cedulaPrestatario: null,
        telefonoPrestatario: null,
        montoUsd: 0,
        montoBs: 0,
        interesPorcentaje: 0,
        fechaVencimiento: '',
        numeroCuotas: 1,
        metodoPago: 'efectivo',
        referenciaPago: '',
        motivo: '',
        observaciones: '',
        idUsuarioRegistro: null,
        fechaPrestamo: ''
      },
      buscarTexto: '',
      resultadosBusqueda: [],
      prestatarioSeleccionado: null,
      cargando: false,
      mostrarResultados: false,
      modoCrear: false,
      guardandoPrestatario: false,
      guardando: false,
      tasaVentaActual: 0,
      cargandoTasa: false,
      
      nuevoCliente: {
        tipoDocumento: 'cedula',
        documento: '',
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        direccion: '',
        estado: 'activo'
      },
      
      nuevoExterno: {
        nombre: '',
        cedula: '',
        telefono: ''
      },
      
      empleados: [],
      clientes: [],
      
      timeoutBusqueda: null,
      
      showConfirmModal: false,
      confirmModalTitle: '',
      confirmModalMessage: '',
      confirmModalIcon: 'mdi:check-circle',
      confirmModalIconClass: 'bg-green-100 dark:bg-green-900/30',
      confirmModalIconColor: 'text-green-600 dark:text-green-400',
      confirmModalConfirmText: 'Aceptar',
      confirmModalCancelText: 'Cancelar',
      confirmModalType: 'success',
      confirmModalConfirmClass: 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
      confirmCallback: null,
      confirmCancelCallback: null
    };
  },
  computed: {
    puedeCrearPrestamo() {
      const baseValid = (
        this.prestatarioSeleccionado &&
        this.form.montoUsd > 0 &&
        this.form.fechaVencimiento &&
        this.form.numeroCuotas >= 1 &&
        this.form.numeroPrestamo
      );
      return baseValid;
    },
    puedeGuardarPrestatario() {
      if (this.form.tipoPrestatario === 'externo') {
        return this.nuevoExterno.nombre && this.nuevoExterno.nombre.trim() !== '';
      }
      if (this.form.tipoPrestatario === 'cliente') {
        return (
          this.nuevoCliente.tipoDocumento &&
          this.nuevoCliente.documento &&
          this.nuevoCliente.nombre &&
          this.nuevoCliente.nombre.trim() !== ''
        );
      }
      return false;
    }
  },
  async mounted() {
    await this.generarNumeroPrestamo();
    this.form.fechaPrestamo = new Date().toISOString().slice(0, 16);
    
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + 30);
    this.form.fechaVencimiento = fecha.toISOString().split('T')[0];
    
    const user = getCurrentUser();
    this.form.idUsuarioRegistro = user?.idUsuario || 1;
    
    await this.cargarListas();
    await this.cargarTasaVenta();
  },
  methods: {
    // ========== UTILIDADES ==========
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value || 0);
    },
    formatCurrencyBs(value) {
      return new Intl.NumberFormat('es-VE', { style: 'currency', currency: 'VES' }).format(value || 0);
    },
    formatearTipoPrestatario(tipo) {
      const map = {
        'empleado': 'Empleado',
        'cliente': 'Cliente',
        'externo': 'Externo'
      };
      return map[tipo] || tipo || 'Desconocido';
    },
    formatearTipoDocumento(tipo) {
      const tipos = {
        'cedula': 'Cédula',
        'rif': 'RIF',
        'pasaporte': 'Pasaporte',
        'identificacion_extranjera': 'Identificación Extranjera'
      };
      return tipos[tipo?.toLowerCase()] || tipo || 'Sin documento';
    },
    getPlaceholderDocumento(tipo) {
      const placeholders = {
        'cedula': 'V-31.757.818',
        'rif': 'J-12345678-9',
        'pasaporte': 'ABC123456',
        'identificacion_extranjera': 'Número de identificación'
      };
      return placeholders[tipo] || 'Número de documento';
    },
    
    // ========== TOAST ==========
    mostrarToastExito(mensaje) { this.toast.success(mensaje, { timeout: 3000 }); },
    mostrarToastError(mensaje) { this.toast.error(mensaje, { timeout: 5000 }); },
    mostrarToastInfo(mensaje) { this.toast.info(mensaje, { timeout: 3000 }); },
    
    // ========== CONFIRMACIÓN ==========
    mostrarConfirmacion(options) {
      this.confirmModalTitle = options.title || 'Confirmar';
      this.confirmModalMessage = options.message || '¿Estás seguro?';
      this.confirmModalIcon = options.icon || 'mdi:help-circle';
      this.confirmModalIconClass = options.iconClass || 'bg-yellow-100 dark:bg-yellow-900/30';
      this.confirmModalIconColor = options.iconColor || 'text-yellow-600 dark:text-yellow-400';
      this.confirmModalConfirmText = options.confirmText || 'Aceptar';
      this.confirmModalCancelText = options.cancelText || 'Cancelar';
      this.confirmModalType = options.type || 'confirm';
      if (options.type === 'danger') this.confirmModalConfirmClass = 'bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700';
      else if (options.type === 'success') this.confirmModalConfirmClass = 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700';
      else this.confirmModalConfirmClass = 'bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700';
      this.confirmCallback = options.onConfirm || null;
      this.confirmCancelCallback = options.onCancel || null;
      this.showConfirmModal = true;
    },
    cancelarConfirmacion() { this.showConfirmModal = false; if (this.confirmCancelCallback) this.confirmCancelCallback(); },
    aceptarConfirmacion() { this.showConfirmModal = false; if (this.confirmCallback) this.confirmCallback(); },
    
    // ========== TASA DE VENTA ==========
    async cargarTasaVenta() {
      this.cargandoTasa = true;
      try {
        const response = await obtenerTasaVentaActual();
        if (response.success && response.data) {
          this.tasaVentaActual = response.data.precio_usd_bs || 0;
          console.log('💰 Tasa de venta actual:', this.tasaVentaActual);
          if (this.form.montoUsd > 0) {
            this.calcularMontoBs();
          }
        } else {
          console.warn('No se pudo obtener la tasa de venta:', response.error);
          this.tasaVentaActual = 0;
        }
      } catch (error) {
        console.error('Error cargando tasa de venta:', error);
        this.tasaVentaActual = 0;
      } finally {
        this.cargandoTasa = false;
      }
    },
    
    // ========== CALCULAR MONTO EN BS ==========
    calcularMontoBs() {
      if (this.tasaVentaActual > 0 && this.form.montoUsd > 0) {
        this.form.montoBs = parseFloat((this.form.montoUsd * this.tasaVentaActual).toFixed(2));
      } else {
        this.form.montoBs = 0;
      }
      this.calcularTotales();
    },
    
    // ========== CARGAR LISTAS ==========
    async cargarListas() {
      try {
        console.log('📥 Cargando listas para búsqueda...');
        
        const resEmpleados = await obtenerUsuarios();
        if (resEmpleados.success) {
          this.empleados = Array.isArray(resEmpleados.data) ? resEmpleados.data : [];
          console.log(`✅ ${this.empleados.length} empleados cargados`);
        } else {
          this.empleados = [];
          console.warn('⚠️ No se pudieron cargar empleados:', resEmpleados.error);
        }
        
        const resClientes = await obtenerClientes();
        if (resClientes.success) {
          this.clientes = Array.isArray(resClientes.data) ? resClientes.data : [];
          console.log(`✅ ${this.clientes.length} clientes cargados`);
        } else {
          this.clientes = [];
          console.warn('⚠️ No se pudieron cargar clientes:', resClientes.error);
        }
        
        console.log('📊 Total cargado - Empleados:', this.empleados.length, 'Clientes:', this.clientes.length);
      } catch (error) {
        console.error('❌ Error cargando listas:', error);
        this.mostrarToastError('Error al cargar datos para búsqueda');
        this.empleados = [];
        this.clientes = [];
      }
    },
    
    cambiarTipo(tipo) {
      this.form.tipoPrestatario = tipo;
      this.buscarTexto = '';
      this.resultadosBusqueda = [];
      this.mostrarResultados = false;
      this.modoCrear = false;
      this.deseleccionarPrestatario();
    },
    
    // ========== GENERAR NÚMERO DE PRÉSTAMO ==========
    async generarNumeroPrestamo() {
      try {
        const año = new Date().getFullYear();
        const { obtenerPrestamos } = await import('@/api/prestamos.js');
        const res = await obtenerPrestamos();
        let ultimoNumero = 0;
        
        if (res.success && res.data) {
          const prestamosAño = res.data.filter(p => p.numeroPrestamo?.startsWith(`PR-${año}-`));
          if (prestamosAño.length > 0) {
            const numeros = prestamosAño.map(p => {
              const partes = p.numeroPrestamo.split('-');
              return partes.length === 3 ? parseInt(partes[2]) : 0;
            });
            ultimoNumero = Math.max(...numeros, 0);
          }
        }
        
        const consecutivo = String(ultimoNumero + 1).padStart(4, '0');
        this.form.numeroPrestamo = `PR-${año}-${consecutivo}`;
        console.log('📋 Número de préstamo generado:', this.form.numeroPrestamo);
      } catch (error) {
        console.error('Error generando número de préstamo:', error);
        const año = new Date().getFullYear();
        this.form.numeroPrestamo = `PR-${año}-0001`;
      }
    },
    
    // ========== BUSCAR PRESTATARIO ==========
    debounceBuscar() {
      if (this.timeoutBusqueda) clearTimeout(this.timeoutBusqueda);
      this.timeoutBusqueda = setTimeout(() => this.buscarPrestatario(), 300);
    },
    
    mostrarResultadosSiHay() {
      if (this.resultadosBusqueda.length > 0) this.mostrarResultados = true;
    },
    
    buscarPrestatario() {
      if (!this.buscarTexto || this.buscarTexto.trim().length < 2) {
        this.resultadosBusqueda = [];
        return;
      }
      
      this.cargando = true;
      const termino = this.buscarTexto.toLowerCase().trim();
      
      setTimeout(() => {
        let lista = [];
        
        if (this.form.tipoPrestatario === 'empleado') {
          lista = this.empleados.map(u => ({
            id: u.idUsuario || u.id || u.id_usuario,
            nombre: u.nombre || '',
            apellido: u.apellido || '',
            documento: u.documento || u.cedula || u.email || '',
            email: u.email || '',
            telefono: u.telefono || '',
            tipo: 'empleado',
            idUsuario: u.idUsuario || u.id || u.id_usuario,
            ...u
          }));
        } else if (this.form.tipoPrestatario === 'cliente') {
          lista = this.clientes.map(c => ({
            id: c.idCliente || c.id || c.id_cliente,
            nombre: c.nombre || '',
            apellido: c.apellido || '',
            documento: c.documento || c.cedula || '',
            email: c.email || '',
            telefono: c.telefono || '',
            tipo: 'cliente',
            idCliente: c.idCliente || c.id || c.id_cliente,
            ...c
          }));
        }
        
        this.resultadosBusqueda = lista.filter(item => {
          const nombreCompleto = `${item.nombre || ''} ${item.apellido || ''}`.toLowerCase();
          const documento = (item.documento || '').toLowerCase();
          const telefono = (item.telefono || '').toLowerCase();
          const email = (item.email || '').toLowerCase();
          return nombreCompleto.includes(termino) || 
                 documento.includes(termino) || 
                 telefono.includes(termino) || 
                 email.includes(termino);
        });
        
        if (this.resultadosBusqueda.length > 10) {
          this.resultadosBusqueda = this.resultadosBusqueda.slice(0, 10);
        }
        
        console.log(`🔍 Resultados para "${termino}": ${this.resultadosBusqueda.length} encontrados`);
        
        this.cargando = false;
      }, 300);
    },
    
    esSeleccionado(item) {
      if (!this.prestatarioSeleccionado) return false;
      return this.prestatarioSeleccionado.id === item.id;
    },
    
    seleccionarPrestatario(item) {
      console.log('✅ Seleccionando prestatario:', item);
      
      this.prestatarioSeleccionado = { ...item };
      
      if (item.tipo === 'empleado') {
        this.form.idUsuario = item.idUsuario || item.id;
        this.form.idCliente = null;
        this.form.nombrePrestatario = null;
        this.form.cedulaPrestatario = null;
        this.form.telefonoPrestatario = null;
      } else if (item.tipo === 'cliente') {
        this.form.idCliente = item.idCliente || item.id;
        this.form.idUsuario = null;
        this.form.nombrePrestatario = null;
        this.form.cedulaPrestatario = null;
        this.form.telefonoPrestatario = null;
      } else if (item.tipo === 'externo') {
        this.form.idUsuario = null;
        this.form.idCliente = null;
        this.form.nombrePrestatario = item.nombre || '';
        this.form.cedulaPrestatario = item.documento || '';
        this.form.telefonoPrestatario = item.telefono || '';
      }
      
      this.buscarTexto = '';
      this.resultadosBusqueda = [];
      this.modoCrear = false;
      
      this.mostrarToastExito(`${this.formatearTipoPrestatario(this.form.tipoPrestatario)} seleccionado: ${item.nombre}`);
    },
    
    deseleccionarPrestatario() {
      this.prestatarioSeleccionado = null;
      this.form.idUsuario = null;
      this.form.idCliente = null;
      this.form.nombrePrestatario = null;
      this.form.cedulaPrestatario = null;
      this.form.telefonoPrestatario = null;
      if (this.buscarTexto) {
        this.mostrarToastInfo('Prestatario removido');
      }
    },
    
    // ========== GUARDAR NUEVO PRESTATARIO ==========
    async guardarNuevoPrestatario() {
      if (!this.puedeGuardarPrestatario) {
        this.mostrarToastError('Complete los campos requeridos');
        return;
      }
      
      this.guardandoPrestatario = true;
      try {
        if (this.form.tipoPrestatario === 'externo') {
          const nuevoExterno = {
            id: Date.now(),
            nombre: this.nuevoExterno.nombre,
            apellido: '',
            documento: this.nuevoExterno.cedula || '',
            telefono: this.nuevoExterno.telefono || '',
            tipo: 'externo'
          };
          
          this.seleccionarPrestatario(nuevoExterno);
          
          this.mostrarToastExito('Externo registrado correctamente');
          this.modoCrear = false;
          this.nuevoExterno = { nombre: '', cedula: '', telefono: '' };
          this.guardandoPrestatario = false;
          return;
        }
        
        if (this.form.tipoPrestatario === 'cliente') {
          const datos = {
            tipoDocumento: this.nuevoCliente.tipoDocumento || 'cedula',
            documento: this.nuevoCliente.documento || '',
            nombre: this.nuevoCliente.nombre || '',
            apellido: this.nuevoCliente.apellido || '',
            telefono: this.nuevoCliente.telefono || '',
            email: this.nuevoCliente.email || '',
            direccion: this.nuevoCliente.direccion || '',
            estado: 'activo'
          };
          
          const { crearCliente } = await import('@/api/clientes.js');
          const res = await crearCliente(datos);
          
          if (res.success && res.data) {
            const resultado = res.data;
            
            const nuevoClienteItem = {
              id: resultado.idCliente || resultado.id || Date.now(),
              nombre: resultado.nombre || datos.nombre,
              apellido: resultado.apellido || datos.apellido || '',
              documento: resultado.documento || datos.documento,
              telefono: resultado.telefono || datos.telefono || '',
              email: resultado.email || datos.email || '',
              tipo: 'cliente',
              idCliente: resultado.idCliente || resultado.id || Date.now()
            };
            
            this.clientes.push({
              idCliente: nuevoClienteItem.idCliente,
              nombre: nuevoClienteItem.nombre,
              apellido: nuevoClienteItem.apellido,
              documento: nuevoClienteItem.documento,
              telefono: nuevoClienteItem.telefono,
              email: nuevoClienteItem.email
            });
            
            this.seleccionarPrestatario(nuevoClienteItem);
            
            this.mostrarToastExito('Cliente creado correctamente');
            this.modoCrear = false;
            this.nuevoCliente = {
              tipoDocumento: 'cedula',
              documento: '',
              nombre: '',
              apellido: '',
              telefono: '',
              email: '',
              direccion: '',
              estado: 'activo'
            };
          } else {
            throw new Error(res.error || 'No se pudo crear el cliente');
          }
        } else if (this.form.tipoPrestatario === 'empleado') {
          this.mostrarToastInfo('Para crear empleados, usa el módulo de Usuarios');
          this.guardandoPrestatario = false;
          return;
        }
      } catch (error) {
        console.error('Error creando prestatario:', error);
        this.mostrarToastError(error.message || 'No se pudo crear el prestatario');
      } finally {
        this.guardandoPrestatario = false;
      }
    },
    
    // ========== CÁLCULOS ==========
    calcularTotales() {
      // Solo para actualizar el resumen
    },
    
    calcularInteresUsd() {
      return (this.form.montoUsd || 0) * (this.form.interesPorcentaje || 0) / 100;
    },
    
    calcularInteresBs() {
      return (this.form.montoBs || 0) * (this.form.interesPorcentaje || 0) / 100;
    },
    
    calcularTotalDeudaUsd() {
      return (this.form.montoUsd || 0) + this.calcularInteresUsd();
    },
    
    calcularTotalDeudaBs() {
      return (this.form.montoBs || 0) + this.calcularInteresBs();
    },
    
    // ========== CREAR PRÉSTAMO ==========
    async crearPrestamo() {
      if (!this.puedeCrearPrestamo) {
        this.mostrarToastError('Complete todos los campos requeridos');
        return;
      }
      
      this.guardando = true;
      try {
        const data = {
          tipoPrestatario: this.form.tipoPrestatario,
          idUsuario: this.form.idUsuario,
          idCliente: this.form.idCliente,
          nombrePrestatario: this.form.nombrePrestatario,
          cedulaPrestatario: this.form.cedulaPrestatario,
          telefonoPrestatario: this.form.telefonoPrestatario,
          montoUsd: parseFloat(this.form.montoUsd || 0),
          montoBs: parseFloat(this.form.montoBs || 0),
          interesPorcentaje: parseFloat(this.form.interesPorcentaje || 0),
          fechaVencimiento: this.form.fechaVencimiento,
          numeroCuotas: parseInt(this.form.numeroCuotas || 1),
          metodoPago: this.form.metodoPago || 'efectivo',
          referenciaPago: this.form.referenciaPago || '',
          motivo: this.form.motivo || '',
          observaciones: this.form.observaciones || '',
          idUsuarioRegistro: this.form.idUsuarioRegistro
        };
        
        console.log('📦 Creando préstamo:', data);
        const result = await crearPrestamo(data);
        
        if (result.success) {
          const prestamoCreado = result.data;
          const mensajeExito = `
            <div class="text-left space-y-1 sm:space-y-2 text-xs sm:text-sm">
              <p><strong>N° Préstamo:</strong> ${prestamoCreado.numeroPrestamo}</p>
              <p><strong>Prestatario:</strong> ${this.prestatarioSeleccionado.nombre}</p>
              <p><strong>Tipo:</strong> ${this.formatearTipoPrestatario(this.form.tipoPrestatario)}</p>
              <p><strong>Monto USD:</strong> ${this.formatCurrency(this.calcularTotalDeudaUsd())}</p>
              <p><strong>Monto Bs:</strong> ${this.formatCurrencyBs(this.calcularTotalDeudaBs())}</p>
              <p><strong>Cuotas:</strong> ${this.form.numeroCuotas}</p>
              <p><strong>Vencimiento:</strong> ${this.form.fechaVencimiento}</p>
            </div>
          `;
          
          this.mostrarConfirmacion({
            title: '¡Préstamo creado exitosamente!',
            message: mensajeExito,
            icon: 'mdi:check-circle',
            type: 'success',
            confirmText: 'Ver préstamos',
            cancelText: 'Permanecer',
            onConfirm: () => this.$router.push('/prestamos')
          });
        } else {
          throw new Error(result.error || 'No se pudo crear el préstamo');
        }
      } catch (error) {
        console.error('Error creando préstamo:', error);
        this.mostrarToastError(error.message || 'No se pudo crear el préstamo');
      } finally {
        this.guardando = false;
      }
    },
    
    volverAListado() {
      if (this.prestatarioSeleccionado || this.form.montoUsd > 0) {
        this.mostrarConfirmacion({
          title: '¿Salir sin guardar?',
          message: 'Hay información sin guardar. ¿Estás seguro de que quieres salir?',
          icon: 'mdi:alert',
          iconClass: 'bg-yellow-100 dark:bg-yellow-900/30',
          iconColor: 'text-yellow-600 dark:text-yellow-400',
          type: 'warning',
          confirmText: 'Sí, salir',
          cancelText: 'Cancelar',
          onConfirm: () => this.$router.push('/prestamos')
        });
      } else {
        this.$router.push('/prestamos');
      }
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

.relative {
  z-index: 10;
}

.absolute {
  z-index: 9999 !important;
}

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }

.transition-all { transition: all 0.3s ease; }
html { scroll-behavior: smooth; }

@media (max-width: 640px) {
  button { min-height: 44px; min-width: 44px; }
}
</style>